'use client';

import { useEffect } from 'react';

import { useAuthContext } from '@/lib/contexts/auth';

import { setLoggerUser } from '../setup.client';

/**
 * Bridges the app auth system into the logger enhancer pipeline.
 * When the user logs in, their id and email are attached to every LogEntry
 * (subject to enhanced-logging consent). When they log out, context is cleared.
 * Mount once inside AuthProvider (already done in LoggingUserSync in locale layout).
 */
export function useLoggerUserSync() {
  const { getUserDataField, isAuthenticated } = useAuthContext();

  const userId = getUserDataField(u => String(u.id));
  const userEmail = getUserDataField(u => u.email);

  useEffect(() => {
    if (isAuthenticated && userId) {
      setLoggerUser({ id: userId, email: userEmail });
    } else {
      setLoggerUser(undefined);
    }
  }, [isAuthenticated, userId, userEmail]);
}
